export default "__VITE_ASSET__623d34d2__"